/**
 * 返回passive参数，如果不支持，返回false
 */

let passive;
try {
  const opts = Object.defineProperty({}, 'passive', {
    get: function () {
      passive = { passive: true };
      return true;
    }
  });
  addEventListener('test', null, opts);
} catch (e) {
  passive = false;
}

export default passive;


// WEBPACK FOOTER //
// ./node_modules/@kk/utils/src/passive.js